import React, { Component } from 'react';
import cookie from '../../src/cookiecut.png';
import { Button } from '@blueprintjs/core';
import{withRouter,Link} from 'react-router-dom';
import { observer , inject } from 'mobx-react';



@withRouter
@inject("store")
@observer

export default class FormationYes extends Component
{

    back(){
        this.props.store.upsetwith = "nothing";
        this.forceUpdate();
        this.props.history.push("/improve");
    }

    formationyes2(){
        this.props.store.formationyes = "formationyes2";
        this.forceUpdate();
    }

    formationyes3(){
        this.props.store.formationyes = "formationyes3";
        this.forceUpdate();
    }



    
    render()
    {
        return <>
        
        {this.props.store.formationyes == "nothing" &&  <div className = "asktext">
        欢迎来到结构指南~<br/><br/>
        来到这里，说明你已经是成熟的写手啦！<br/>
        只有拥有足够写作经验的作者，才会开始思考结构问题<br/><br/>

        不过结构部分的理论稍微有点复杂<br/>
        因为篇幅原因，这里就只涉及到两个部分<br/>
        故事线和如何写大纲。<br/>
        如果想要看更多讲解，可以去公众号“过雨红素”中看看结构篇<br/><br/>
        好啦，让我们从故事线开始<br/>
        
        
        
       <br/>
       <div className = "buttonbox">

        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.formationyes2() } >故事线讲解</Button><br/>
        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.back() } >不，我要练文笔或情节</Button><br/>
    </div>   
    </div> }

    {this.props.store.formationyes == "formationyes2" &&  <div className = "asktext">
        欢迎来到故事线讲解！<br/>
        在讲故事线之前，先来讲一讲什么是故事<br/><br/>
        故事，是一系列事件，组成的一个大事件<br/>
        比如西游记，是由一个个降妖除魔的小事件组成的，西天取经的大事件<br/>
        哈利波特，是先有许许多多小故事组成一个学年的故事，再由七个学年故事组成的大故事<br/><br/>
        这个“大事件”，就是故事中的主线。<br/>
        主线剧情的发展脉络，就被称为故事线<br/><br/>
        故事线有两个组成部分，一个大事件，以及进度条<br/>
        分别用来描述这个故事在讲什么事，以及讲到哪里了<br/>
        比如哈利波特打算写一个青年魔法师一步步打败了大魔头的故事。<br/>
        打算写七本书，每本书杀死这个魔头的一部分<br/>
        这就定好了基本的大事件和进度条，可以开始写大纲了<br/><br/>
        <div className = "buttonbox">

<Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.formationyes3() } >大纲讲解</Button><br/>
<Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.back() } >不，我要练文笔或情节</Button><br/>
</div>   
        
        </div>}

        {this.props.store.formationyes == "formationyes3" &&  <div className = "asktext">
            欢迎来到大纲讲解！<br/><br/>
            当你制定好基本的主线剧情和进度条之后，就需要把大故事拆分为中故事<br/>
            比如一个小骑士，想要统治世界，是大故事。<br/>
            可以拆分成先征服一个骑士团，然后是一个国家，再打败其他国家，最后征服世界<br/>
            把大故事拆成中故事之后，要描述一个中故事发生了什么<br/>
            大体写一下中故事的发展，大纲就制定好了<br/><br/>
            
            当然大纲写完，并不是不能改动的。<br/>
            如果写着写着偏离了大纲，可以把故事拉回来，也可以及时修改大纲<br/>
            只要记得故事有个主线，以及现在写的小故事，在大故事中是什么位置，起到什么作用。故事就不会写得太散乱了<br/><br/>
            以上就是结构篇的简略讲解啦<br/><br/>
            可以试着把写过的小说，整理出故事线和大纲哦~<br/><br/>
            <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.back() } >返回</Button><br/>

            </div>}

   
        </>;
    }
} 